/*  MUI  */
import { Grid, TableCell, Typography } from '@mui/material';

/*  Shared  */
import { ApplicationNameAdminAppModalCell } from 'application/Shared/Components/ApplicationNameAdminAppModalCell';
import { ManagedTable } from 'application/Shared/Components/Table';
import { hmsFormatter } from 'application/Shared/Helpers';

/* Objects */
import { Application } from 'objects/Application';

/* React */
import React, { useMemo } from 'react';
import { withTranslation } from 'react-i18next';

const PartnerApplicationUsageReports = (props) => {
    const { renderingScheduledReport, reportData, reportSetup, runReport } =
        props;

    if (!reportData) {
        return null;
    }

    const {
        partnerApplicationUsageTopApplicationsUsedTopApplicationsUsedLastWeek
    } = reportData;
    if (
        !partnerApplicationUsageTopApplicationsUsedTopApplicationsUsedLastWeek
    ) {
        return null;
    }

    return (
        <TopApplicationsUsedLastWeek
            {...props}
            renderingScheduledReport={renderingScheduledReport}
            reportSetup={reportSetup}
            reportData={
                partnerApplicationUsageTopApplicationsUsedTopApplicationsUsedLastWeek?.data
            }
            runReport={runReport}
        />
    );
};

const headers = (t) => [
    {
        align: 'left',
        field: 'riubCategory',
        renderHeader: <strong>{t('Common.category')}</strong>,
        width: '40%'
    },
    {
        align: 'left',
        field: 'riubUsers',
        renderHeader: <strong>{t('Common.client_count')}</strong>,
        width: '20%'
    },
    {
        align: 'left',
        field: 'riubUsers',
        renderHeader: <strong>{t('Common.user_count')}</strong>,
        width: '20%'
    },
    {
        align: 'right',
        field: 'riubUsers',
        renderHeader: <strong>{t('Common.usage')}</strong>,
        width: '20%'
    }
];

const TopApplicationsUsedLastWeek = (props) => {
    const {
        renderingScheduledReport,
        reportData,
        reportWrapper,
        runReport,
        t
    } = props;

    const rows = useMemo(() => reportData.data, [reportData.data]);

    const tableHeaders = useMemo(() => headers(t), [t]);

    return (
        <Grid item lg={reportWrapper ? 12 : 4} xs={12}>
            {!reportWrapper && (
                <Typography variant="h5">
                    {t(
                        'Reports.PartnerApplicationOverviewReport.application_usage_by_category_breakdown'
                    )}
                </Typography>
            )}
            <ManagedTable
                headers={tableHeaders}
                renderBody={(row) => (
                    <>
                        <TableCell>
                            <Application data={row.application}>
                                <ApplicationNameAdminAppModalCell
                                    onCloseModal={runReport}
                                    row={row}
                                />
                            </Application>
                        </TableCell>
                        <TableCell>{row.clients.length}</TableCell>
                        <TableCell>{row.users.length}</TableCell>
                        <TableCell align="right">
                            {hmsFormatter(row.usage)}
                        </TableCell>
                    </>
                )}
                renderBodyKey={null}
                renderFooter={!renderingScheduledReport}
                rows={rows}
                rowsPerPage={-1}
                searchEnabled={false}
                sortDirection="DESC"
                sortFieldType="number"
                sortKey="applicationCount"
            />
        </Grid>
    );
};

export default withTranslation()(PartnerApplicationUsageReports);
